// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#V-C67B9C85-D5E5-4DB8-802C-A0876EB9095C {\n  min-height: 80vh;\n}\n", "",{"version":3,"sources":["webpack://src/formBuilder/components/dummyPlaceHolder/dummyPlaceHolder.less"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ","sourcesContent":["#V-C67B9C85-D5E5-4DB8-802C-A0876EB9095C{\n    min-height: 80vh;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
